<div class="sweet-alert showSweetAlert visible" data-custom-class="" data-has-cancel-button="false" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="false" data-animation="pop" data-timer="null">

    <div class="sa-icon sa-error" style="display: none;">
        <span class="sa-x-mark">
      <span class="sa-line sa-left"></span>
        <span class="sa-line sa-right"></span>
        </span>
    </div>

    <div class="sa-icon sa-warning" style="display: none;">
        <span class="sa-body"></span>
        <span class="sa-dot"></span>
    </div>

    <div class="sa-icon sa-info" style="display: none;"></div>

    <div class="sa-icon sa-success animate" style="display: block;">
        <span class="sa-line sa-tip animateSuccessTip"></span>
        <span class="sa-line sa-long animateSuccessLong"></span>
        <div class="sa-placeholder"></div>
        <div class="sa-fix"></div>
    </div>

    <div class="sa-icon sa-custom" style="display: none;"></div>

    <h2>Congrats!</h2>
    <p style="display: block;">You're email has been added to our special offers list.</p>

    <div class="sa-error-container">
        <div class="icon">!</div>
        <p>Not valid!</p>
    </div>

    <div class="sa-button-container">
        <button class="cancel" tabindex="2" style="display: none;" (click)="closePopup()">Cancel</button>
        <button class="confirm" tabindex="1" style="display: inline-block; background-color: rgb(241, 92, 34); box-shadow: rgba(241, 92, 34, 0.8) 0px 0px 2px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset;" (click)="closePopup()">OK</button>
    </div>

</div>